import userDefaultIcon from './user_default.svg'

export const icons = {
	userDefaultIcon
}